import styled from 'styled-components';
import { ColouredImageMask } from '../../images/ColouredMask';
import src from './IconMapMarker.background.svg';

export const IconMapMarker = styled(ColouredImageMask).attrs({ src: String(src) })`
  height: 24px;
  width: 24px;
`;
